import React, { useState, useEffect } from "react";
import "./PerfEvalCEOTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faEdit,
  // faEye,
  // faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Form, Button, Row } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
// import ViewModal from "./ViewModal";
// import { Link } from "react-router-dom";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

export default function PerfEvalCEOTable(props) {
  const [PerfEvalCEOData, setPerfEvalCEOData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [SelectedEmp, setSelectedEmp] = useState(props.SelectedEmpID);
  const [EmpName, setEmpName] = useState(props.SelectedEmpName);
  const [SelectedYear, setSelectedYear] = useState("");
  const [UniqueYears, setUniqueYears] = useState([]);

  const renderDelButton = (params) => {
    // console.log(params.data.data["_id"]);
    if (props.back) {
      return <React.Fragment />;
    }
    return (
      params.data.monthyear.includes("20") && (
        <Button
          variant="light"
          onClick={() =>
            onPerfEvalCEODelete(SelectedEmp, params.data.data["_id"])
          }>
          <FontAwesomeIcon icon={faTrash} />
          &nbsp;&nbsp;Delete
        </Button>
      )
    );
  };

  const renderEditButton = (params) => {
    if (props.back) {
      return <React.Fragment />;
    }
    return (
      params.data.monthyear.includes("20") && (
        <Button
          variant="light"
          onClick={() => props.onEditPerfEvalCEO(params.data.data)}>
          <FontAwesomeIcon icon={faEdit} />
          &nbsp;&nbsp;Edit
        </Button>
      )
    );
  };

  const columnDefs = [
    {
      headerName: "Month & Year",
      field: "monthyear",
      // filter: true ,
    },
    {
      headerName: "Communication Skills",
      field: "communication",
      // filter: true ,
    },
    {
      headerName: "Collaboration and Teamwork",
      field: "collaboration",
      // filter: true ,
    },
    {
      headerName: "Problem Solving ",
      field: "problemsolving",

      // filter: true ,
    },
    {
      headerName: "Quality and Accuracy of work",
      field: "quality",

      // filter: true ,
    },
    {
      headerName: "Attendance, punctuality and reliability",
      field: "attendance",

      // filter: true ,
    },
    {
      headerName: "Accomplish Goals and Meet deadlines",
      field: "meetdeadline",
      // filter: true ,
    },
    {
      headerName: "Month's Total",
      field: "MonthsTotal",
      // filter: true ,
    },

    {
      headerName: "Edit",
      field: "edit",

      cellRendererFramework: renderEditButton,
    },
    {
      headerName: "Delete",
      field: "delete",

      cellRendererFramework: renderDelButton,
    },
  ];

  const defaultColDef = {
    lockPosition: "ture",
    cellClass: "locked-col",
    width: 120,
    resizable: true,
    sortable: true,
    wrapText: true, // <-- HERE
    autoHeight: true, // <-- & HERE

    // filter: true ,
  };
  const getRowHeight = () => {
    return 55;
  };

  const loadPerfEvalCEOData = () => {
    setLoading(true);
    axios
      .get(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/perfeval-ceo/" +
          localStorage.getItem("department"),
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((response) => {
        setPerfEvalCEOData([]);
        setRowData([]);
        setPerfEvalCEOData(response.data);
        setLoading(false);
        if (props.SelectedEmpID !== "" && props.SelectedEmpName !== "") {
          setSelectedEmp(props.SelectedEmpID);
          setEmpName(props.SelectedEmpName);
          const d = new Date();
          let currentyear = d.getFullYear();

          SelectEmp(response.data, props.SelectedEmpID, currentyear);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onPerfEvalCEODelete = (e1, e2) => {
    // console.log(e1, e2);
    if (window.confirm("Are you sure to delete this record? ") === true) {
      setLoading(true);
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/perfeval-ceo/" +
            e1 +
            "/" +
            e2,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((response) => {
          setPerfEvalCEOData(response.data);
          setLoading(false);

          if (props.SelectedEmpID !== "" && props.SelectedEmpName !== "") {
            setSelectedEmp(props.SelectedEmpID);
            setEmpName(props.SelectedEmpName);

            SelectEmp(response.data, props.SelectedEmpID, SelectedYear);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  useEffect(() => {
    loadPerfEvalCEOData();
  }, []);

  const SelectUniqeYear = (DataArray) => {
    let UYears = [];

    DataArray.filter((dta) => {
      var year = dta["monthyear"].split(" ")[1];
      return !UYears.includes(year) ? UYears.push(year) : "";
    });
    setUniqueYears(UYears);
  };
  const GetMonthIndex = (MonthName) => {
    if (MonthName == "Janurary") {
      return 0;
    }
    if (MonthName == "February") {
      return 1;
    }
    if (MonthName == "March") {
      return 2;
    }
    if (MonthName == "April") {
      return 3;
    }
    if (MonthName == "May") {
      return 4;
    }
    if (MonthName == "June") {
      return 5;
    }
    if (MonthName == "July") {
      return 6;
    }
    if (MonthName == "August") {
      return 7;
    }
    if (MonthName == "September") {
      return 8;
    }
    if (MonthName == "October") {
      return 9;
    }
    if (MonthName == "November") {
      return 10;
    }
    if (MonthName == "December") {
      return 11;
    }
  };

  const SelectEmp = (Data, idd, yrSelected) => {
    Data.forEach((data) => {
      if (data._id == idd) {
        // console.log(data["perfeval"]);
        let rowDataT = ["", "", "", "", "", "", "", "", "", "", "", ""];
        let aggregate = [0, 0, 0, 0, 0, 0, 0];
        SelectUniqeYear(data["perfeval"]);
        setSelectedYear(yrSelected);

        data["perfeval"].filter((data) => {
          if (data["monthyear"].split(" ")[1] == yrSelected) {
            let temp = {
              data,
              monthyear: data.monthyear,
              communication: data.communication + "/10",
              collaboration: data.collaboration + "/10",
              problemsolving: data.problemsolving + "/10",
              quality: data.quality + "/10",
              attendance: data.attendance + "/10",
              meetdeadline: data.meetdeadline + "/10",
              MonthsTotal:
                Number(data.communication) +
                Number(data.collaboration) +
                Number(data.problemsolving) +
                Number(data.quality) +
                Number(data.attendance) +
                Number(data.meetdeadline),
            };
            aggregate[0] = aggregate[0] + Number(data.communication);
            aggregate[1] = aggregate[1] + Number(data.collaboration);
            aggregate[2] = aggregate[2] + Number(data.problemsolving);
            aggregate[3] = aggregate[3] + Number(data.quality);
            aggregate[4] = aggregate[4] + Number(data.attendance);
            aggregate[5] = aggregate[5] + Number(data.meetdeadline);
            aggregate[6] =
              aggregate[6] +
              Number(
                Number(data.communication) +
                  Number(data.collaboration) +
                  Number(data.problemsolving) +
                  Number(data.quality) +
                  Number(data.attendance) +
                  Number(data.meetdeadline)
              );
            const mindex = GetMonthIndex(data["monthyear"].split(" ")[0]);
            rowDataT[mindex] = temp;
          }
        });
        let temp15 = {
          monthyear: "",
          communication: "",
          collaboration: "",
          problemsolving: "",
          quality: "",
          attendance: "",
          meetdeadline: "",
          MonthsTotal: "",
        };
        rowDataT.push(temp15);

        let temp2 = {
          monthyear: "Yearly Total",
          communication: String(aggregate[0]),
          collaboration: String(aggregate[1]),
          problemsolving: String(aggregate[2]),
          quality: String(aggregate[3]),
          attendance: String(aggregate[4]),
          meetdeadline: String(aggregate[5]),
          MonthsTotal: String(aggregate[6]),
        };
        rowDataT.push(temp2);

        rowDataT = rowDataT.filter(function (el) {
          return el !== "";
        });

        setRowData(rowDataT);
      }
      return;
    });
  };
  const ClearSelection = () => {
    setSelectedEmp("");
    setRowData([]);
    setEmpName("");
    props.SetNameID("", "");
    setSelectedYear("");
  };
  return (
    <div id="table-outer-div-scroll">
      <h2 id="role-title">Employee Performance Evaluation</h2>
      <Form.Group as={Row} className="mr-md-2 ml-md-2">
        {EmpName === "" && (
          <Form.Label column sm={8}>
            Select Employee's Name
          </Form.Label>
        )}
      </Form.Group>
      {SelectedEmp === "" &&
        PerfEvalCEOData.map(
          (data, index) =>
            data["perfeval"].length >= 0 && (
              <Button
                style={{ margin: "10px" }}
                key={index}
                onClick={() => {
                  setSelectedEmp(data["_id"]);
                  setEmpName(data["FirstName"] + " " + data["LastName"]);
                  const d = new Date();
                  let currentyear = d.getFullYear();

                  SelectEmp(PerfEvalCEOData, data["_id"], currentyear);
                  props.SetNameID(
                    data["FirstName"] + " " + data["LastName"],
                    data["_id"]
                  );
                }}>
                {data["FirstName"] +
                  " " +
                  data["LastName"] +
                  " (" +
                  data["perfeval"].length +
                  " Evaluations)"}
              </Button>
            )
        )}
      {SelectedEmp !== "" && (
        <Button style={{ margin: "10px" }} onClick={ClearSelection}>
          &#11164; All Employee
        </Button>
      )}
      <br />
      {SelectedEmp !== "" && (
        <Button
          variant="primary"
          id="add-button"
          onClick={props.onAddPerfEvalCEO}>
          <FontAwesomeIcon icon={faPlus} id="plus-icon" />
          Add
        </Button>
      )}
      {EmpName !== "" && <h3>{EmpName}</h3>}
      <br />
      {UniqueYears.length > 0 &&
        UniqueYears.map((yr, indx) => (
          <Button
            variant="primary"
            id="add-button"
            key={indx}
            onClick={() => {
              setSelectedYear(yr);
              SelectEmp(PerfEvalCEOData, props.SelectedEmpID, yr);
            }}
            disabled={yr == SelectedYear}>
            Year - {yr}
          </Button>
        ))}
      <br />
      <div id="clear-both" />
      {!loading ? (
        <div id="table-div" className="ag-theme-balham">
          {SelectedEmp !== "" && rowData.length >= 0 && (
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              suppressDragLeaveHidesColumns={true}
              headerHeight={90}
              rowData={rowData}
              pagination={true}
              paginationPageSize={20}
              getRowHeight={getRowHeight}
            />
          )}
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </div>
  );
}
